<template>
  <div>
    <div :class="{'bg-primarySelected' : !isCurrentToggle }"
         class="d-flex justify-content-between align-items-center pdl-20 pdr-4 mgt-12 b-radius4 mgb-12 cursor-pointer"
         @click="toggleMoreMethod">
      <div class="t-body2 t-color-primary font-r">{{ $t(listNameCode) }}</div>
      <button class="mdc-icon-button content-trigger h-40 d-flex align-items-center" tabindex="0">
        <i ref="toggle" class="material-icons t-headline12 t-color-bodyGrayA">{{isCurrentToggle ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</i></button>
    </div>
    <div ref="content" :style="isCurrentToggle ? { 'display': 'none' } : {'display': 'block'}" class="detail-content" >
      <div v-for="(list, key, index) in aggregation.options.slice(0, 3)"
           :key="index"
           class="pdt-4 pdb-4 pdl-10 pdr-20 d-flex align-items-center">
        <div class="">
          <div class="mdc-form-field" >
            <div :class="{'mdc-checkbox--disabled cursor-default' : !list.count}"
                 class="mdc-checkbox">
	            <input :id="'checkbox-' + aggregation.type + list.title + '-' + list.id"
                     v-model="aggregation.value"
	                   :disabled="!list.count"
                     :name="aggregation.type"
                     :value="listValueCal(aggregation.type, list)"
                     class="mdc-checkbox__native-control"
                     tabindex="0"
                     type="checkbox"
                     @change="onCheckChange()"
              />
              <div class="mdc-checkbox__background check-red" tabindex="0">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path class="mdc-checkbox__checkmark-path" d="M1.73,12.91 8.1,19.28 22.79,4.59"
                        fill="none"/>
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
            <label id="radioBtn"
                   :for="'checkbox-' + aggregation.type + list.title + '-' + list.id"
                   v-html="isLabelCount(getTranslateCode(list.title), list.count)"></label>
          </div>
        </div>
      </div>

      <div v-if="aggregation.options.length > 3" class="more-content-wrapper">
        <div ref="more" class="more-detail-content d-none">
          <div v-for="(list, index) in aggregation.options.slice(3, aggregation.options.length)" :key="index" class="pdt-4 pdb-4 pdl-10 pdr-20 d-flex align-items-center">
            <div class="">
              <div class="mdc-form-field" >
                <div :class="{'mdc-checkbox--disabled cursor-default' : !list.count}"
                     class="mdc-checkbox">
                  <input :id="'checkbox-'+ aggregation.type + list.title + '-' + list.id"
                         v-model="aggregation.value"
                         :disabled="!list.count"
                         :value="listValueCal(aggregation.type, list)"
                         class="mdc-checkbox__native-control"
                         tabindex="0"
                         type="checkbox"
                         @change="onCheckChange()"
                  />
                  <div class="mdc-checkbox__background check-red" tabindex="0">
                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                      <path class="mdc-checkbox__checkmark-path" d="M1.73,12.91 8.1,19.28 22.79,4.59"
                            fill="none"/>
                    </svg>
                    <div class="mdc-checkbox__mixedmark"></div>
                  </div>
                  <!-- 	<div class="mdc-checkbox__ripple"></div> -->
                </div>
                <label id="radioBtn"
                       :for="'checkbox-'+ aggregation.type + list.title + '-' + list.id"
                       v-html="isLabelCount(getTranslateCode(list.title), list.count)">
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex pdt-4 pdb-4 align-items-center pdl-20 pdr-4 b-radius4 mgb-8 cursor-pointer" @click="seeMoreMethod">
          <div ref="moreText" class="t-body2 t-color-bodyGrayA font-r">{{ $t("30014") }}</div>
          <button class="mdc-icon-button show-more-content h-40 d-flex align-items-center" tabindex="0">
            <i ref="icon"
              class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_down</i></button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {FILTER_LIST} from "@/components/microDegree/utils/constants";

export default {
  name: "FilterTab",

  props: {
	  aggregation: Object,
	  isToggle: Boolean
  },

  data() {
    return {
      listNameCode: '',
      list_checked: [],
	    isCurrentToggle: false,
	    translateData: {
		    FREE: '30038',
		    NOT_FREE: '30039',
		    ZERO_TO_ONE: '30026',
		    ONE_TO_THREE: '30027',
		    THREE_TO_SIX: '30028',
		    SIX_TO_TWELVE: '30029',
		    OVER_TWELVE: '30030',
		    ko: "30097",
		    en: "30096",
		    km: "30103",
		    ar: "30106",
		    "zh-CN": "30098",
		    "zh-TW": "30099",
		    de: "30102",
		    pt: "30101",
		    es: "30100",
		    hi: "30105",
		    sw: "30104",
		    COMPUTER_SCIENCE: "30032",
		    LIVE_SESSION: "30033",
		    EXAM: "30034"
	    },
    }
  },

  created() {
    this.listNameCode = FILTER_LIST[this.aggregation.type.toLowerCase()].code
  },

  mounted() {
	  this.isCurrentToggle = this.aggregation.value.length ? false : this.isToggle;
  },

  methods: {
    onCheckChange() {
      this.$emit('onCheckChange');
    },

    toggleMoreMethod() {
	    this.isCurrentToggle = !this.isCurrentToggle;
    },

    seeMoreMethod() {
      const more = this.$refs.more;
      const icon = this.$refs.icon;
	    const moreText = this.$refs.moreText;
      if (more.classList.contains('d-none')) {
        more.classList.remove('d-none');
        icon.innerHTML = 'keyboard_arrow_up';
	      moreText.innerText = this.$t("30015");
      } else {
        more.classList.add('d-none');
        icon.innerHTML = 'keyboard_arrow_down';
	      moreText.innerText = this.$t("30014");
      }
    },

    listValueCal(type, list) {
      switch (type) {
        case FILTER_LIST.course_language.name:
        case FILTER_LIST.subtitle_language.name:
          return list.code;
        case FILTER_LIST.price.name:
          return list.title === 'FREE';
        default:
          return list.id ? list.id : list.title;
      }
    },

    isLabelCount(title, count) {
      const className = count ? 't-color-bodyGrayA' : 't-color-iconInactive cursor-default';
      return `<div class="d-flex pdb-2 ${className}"><div class="pdr-4">${title}</div><div>(${count})</div></div>`;
    },

    getTranslateCode(title) {
      return Object.keys(this.translateData).includes(title) ? this.$t(this.translateData[title]) : title;
    }
  }
}
</script>

<style scoped>
#radioBtn >>> div {
  font-family: noto-regular !important;
  font-size: 0.875rem;
  font-weight: 500;
}
</style>
